// Shim: the ported builder renders <AppHeader/>. Our AppLayout already provides
// the sidebar chrome, so this is a no-op.
export function AppHeader() {
  return null;
}
export default AppHeader;
